import { render, staticRenderFns } from "./index.vue?vue&type=template&id=88826b9c&scoped=true&lang=pug"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=88826b9c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88826b9c",
  null
  
)

export default component.exports